const useAuth = () => {
    const token = localStorage.getItem('admin_token');
    // Existing admin login stores admin_user; CRM login stores admin_info
    const raw = localStorage.getItem('admin_info') || localStorage.getItem('admin_user');
    const user = raw ? JSON.parse(raw) : null;

    return {
        token,
        user,
        isLoggedIn: !!token,
        // Admin model has no role field — all admins are admins by definition
        // CRM staff users have explicit role field
        isAdmin: user?.role === 'admin' || (!!token && !user?.role),
        isStaff: user?.role === 'staff',
    };
};

export default useAuth;
